import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
    selector: 'ConfirmDialog',
    templateUrl: 'confirmpopup.html',
})
export class ConfirmPopup {

   

    header:string;
    message:string;
    description:string;

    constructor(public dialogRef: MatDialogRef<ConfirmPopup>,
         @Inject(MAT_DIALOG_DATA) public data: any)
    {
        this.header=data.header;
        this.message=data.message;
        this.description=data.description;
       
     
    }

    
    
    yesClick(): void {
        this.dialogRef.close('yes');
    }

    noClick(): void {
        this.dialogRef.close('no');
    }

   


}